/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiCompetitionGet$Any } from '../fn/competition/api-competition-get-any';
import { ApiCompetitionGet$Any$Params } from '../fn/competition/api-competition-get-any';
import { apiCompetitionGet$Json } from '../fn/competition/api-competition-get-json';
import { ApiCompetitionGet$Json$Params } from '../fn/competition/api-competition-get-json';
import { apiCompetitionGet$JsonOdataMetadataFull } from '../fn/competition/api-competition-get-json-odata-metadata-full';
import { ApiCompetitionGet$JsonOdataMetadataFull$Params } from '../fn/competition/api-competition-get-json-odata-metadata-full';
import { apiCompetitionGet$JsonOdataMetadataFullOdataStreamingFalse } from '../fn/competition/api-competition-get-json-odata-metadata-full-odata-streaming-false';
import { ApiCompetitionGet$JsonOdataMetadataFullOdataStreamingFalse$Params } from '../fn/competition/api-competition-get-json-odata-metadata-full-odata-streaming-false';
import { apiCompetitionGet$JsonOdataMetadataFullOdataStreamingTrue } from '../fn/competition/api-competition-get-json-odata-metadata-full-odata-streaming-true';
import { ApiCompetitionGet$JsonOdataMetadataFullOdataStreamingTrue$Params } from '../fn/competition/api-competition-get-json-odata-metadata-full-odata-streaming-true';
import { apiCompetitionGet$JsonOdataMetadataMinimal } from '../fn/competition/api-competition-get-json-odata-metadata-minimal';
import { ApiCompetitionGet$JsonOdataMetadataMinimal$Params } from '../fn/competition/api-competition-get-json-odata-metadata-minimal';
import { apiCompetitionGet$JsonOdataMetadataMinimalOdataStreamingFalse } from '../fn/competition/api-competition-get-json-odata-metadata-minimal-odata-streaming-false';
import { ApiCompetitionGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params } from '../fn/competition/api-competition-get-json-odata-metadata-minimal-odata-streaming-false';
import { apiCompetitionGet$JsonOdataMetadataMinimalOdataStreamingTrue } from '../fn/competition/api-competition-get-json-odata-metadata-minimal-odata-streaming-true';
import { ApiCompetitionGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params } from '../fn/competition/api-competition-get-json-odata-metadata-minimal-odata-streaming-true';
import { apiCompetitionGet$JsonOdataMetadataNone } from '../fn/competition/api-competition-get-json-odata-metadata-none';
import { ApiCompetitionGet$JsonOdataMetadataNone$Params } from '../fn/competition/api-competition-get-json-odata-metadata-none';
import { apiCompetitionGet$JsonOdataMetadataNoneOdataStreamingFalse } from '../fn/competition/api-competition-get-json-odata-metadata-none-odata-streaming-false';
import { ApiCompetitionGet$JsonOdataMetadataNoneOdataStreamingFalse$Params } from '../fn/competition/api-competition-get-json-odata-metadata-none-odata-streaming-false';
import { apiCompetitionGet$JsonOdataMetadataNoneOdataStreamingTrue } from '../fn/competition/api-competition-get-json-odata-metadata-none-odata-streaming-true';
import { ApiCompetitionGet$JsonOdataMetadataNoneOdataStreamingTrue$Params } from '../fn/competition/api-competition-get-json-odata-metadata-none-odata-streaming-true';
import { apiCompetitionGet$JsonOdataStreamingFalse } from '../fn/competition/api-competition-get-json-odata-streaming-false';
import { ApiCompetitionGet$JsonOdataStreamingFalse$Params } from '../fn/competition/api-competition-get-json-odata-streaming-false';
import { apiCompetitionGet$JsonOdataStreamingTrue } from '../fn/competition/api-competition-get-json-odata-streaming-true';
import { ApiCompetitionGet$JsonOdataStreamingTrue$Params } from '../fn/competition/api-competition-get-json-odata-streaming-true';
import { apiCompetitionGet$Plain } from '../fn/competition/api-competition-get-plain';
import { ApiCompetitionGet$Plain$Params } from '../fn/competition/api-competition-get-plain';
import { apiCompetitionGet$Xml } from '../fn/competition/api-competition-get-xml';
import { ApiCompetitionGet$Xml$Params } from '../fn/competition/api-competition-get-xml';
import { CompetitionModelListResult } from '../models/competition-model-list-result';

@Injectable({ providedIn: 'root' })
export class CompetitionService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiCompetitionGet()` */
  static readonly ApiCompetitionGetPath = '/api/competition';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCompetitionGet$JsonOdataMetadataMinimalOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCompetitionGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params?: ApiCompetitionGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<CompetitionModelListResult>> {
    return apiCompetitionGet$JsonOdataMetadataMinimalOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCompetitionGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCompetitionGet$JsonOdataMetadataMinimalOdataStreamingTrue(params?: ApiCompetitionGet$JsonOdataMetadataMinimalOdataStreamingTrue$Params, context?: HttpContext): Observable<CompetitionModelListResult> {
    return this.apiCompetitionGet$JsonOdataMetadataMinimalOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<CompetitionModelListResult>): CompetitionModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCompetitionGet$JsonOdataMetadataMinimalOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCompetitionGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params?: ApiCompetitionGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<CompetitionModelListResult>> {
    return apiCompetitionGet$JsonOdataMetadataMinimalOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCompetitionGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCompetitionGet$JsonOdataMetadataMinimalOdataStreamingFalse(params?: ApiCompetitionGet$JsonOdataMetadataMinimalOdataStreamingFalse$Params, context?: HttpContext): Observable<CompetitionModelListResult> {
    return this.apiCompetitionGet$JsonOdataMetadataMinimalOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<CompetitionModelListResult>): CompetitionModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCompetitionGet$JsonOdataMetadataMinimal()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCompetitionGet$JsonOdataMetadataMinimal$Response(params?: ApiCompetitionGet$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<StrictHttpResponse<CompetitionModelListResult>> {
    return apiCompetitionGet$JsonOdataMetadataMinimal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCompetitionGet$JsonOdataMetadataMinimal$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCompetitionGet$JsonOdataMetadataMinimal(params?: ApiCompetitionGet$JsonOdataMetadataMinimal$Params, context?: HttpContext): Observable<CompetitionModelListResult> {
    return this.apiCompetitionGet$JsonOdataMetadataMinimal$Response(params, context).pipe(
      map((r: StrictHttpResponse<CompetitionModelListResult>): CompetitionModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCompetitionGet$JsonOdataMetadataFullOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCompetitionGet$JsonOdataMetadataFullOdataStreamingTrue$Response(params?: ApiCompetitionGet$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<CompetitionModelListResult>> {
    return apiCompetitionGet$JsonOdataMetadataFullOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCompetitionGet$JsonOdataMetadataFullOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCompetitionGet$JsonOdataMetadataFullOdataStreamingTrue(params?: ApiCompetitionGet$JsonOdataMetadataFullOdataStreamingTrue$Params, context?: HttpContext): Observable<CompetitionModelListResult> {
    return this.apiCompetitionGet$JsonOdataMetadataFullOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<CompetitionModelListResult>): CompetitionModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCompetitionGet$JsonOdataMetadataFullOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCompetitionGet$JsonOdataMetadataFullOdataStreamingFalse$Response(params?: ApiCompetitionGet$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<CompetitionModelListResult>> {
    return apiCompetitionGet$JsonOdataMetadataFullOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCompetitionGet$JsonOdataMetadataFullOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCompetitionGet$JsonOdataMetadataFullOdataStreamingFalse(params?: ApiCompetitionGet$JsonOdataMetadataFullOdataStreamingFalse$Params, context?: HttpContext): Observable<CompetitionModelListResult> {
    return this.apiCompetitionGet$JsonOdataMetadataFullOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<CompetitionModelListResult>): CompetitionModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCompetitionGet$JsonOdataMetadataFull()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCompetitionGet$JsonOdataMetadataFull$Response(params?: ApiCompetitionGet$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<StrictHttpResponse<CompetitionModelListResult>> {
    return apiCompetitionGet$JsonOdataMetadataFull(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCompetitionGet$JsonOdataMetadataFull$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCompetitionGet$JsonOdataMetadataFull(params?: ApiCompetitionGet$JsonOdataMetadataFull$Params, context?: HttpContext): Observable<CompetitionModelListResult> {
    return this.apiCompetitionGet$JsonOdataMetadataFull$Response(params, context).pipe(
      map((r: StrictHttpResponse<CompetitionModelListResult>): CompetitionModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCompetitionGet$JsonOdataMetadataNoneOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCompetitionGet$JsonOdataMetadataNoneOdataStreamingTrue$Response(params?: ApiCompetitionGet$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<CompetitionModelListResult>> {
    return apiCompetitionGet$JsonOdataMetadataNoneOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCompetitionGet$JsonOdataMetadataNoneOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCompetitionGet$JsonOdataMetadataNoneOdataStreamingTrue(params?: ApiCompetitionGet$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<CompetitionModelListResult> {
    return this.apiCompetitionGet$JsonOdataMetadataNoneOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<CompetitionModelListResult>): CompetitionModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCompetitionGet$JsonOdataMetadataNoneOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCompetitionGet$JsonOdataMetadataNoneOdataStreamingFalse$Response(params?: ApiCompetitionGet$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<CompetitionModelListResult>> {
    return apiCompetitionGet$JsonOdataMetadataNoneOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCompetitionGet$JsonOdataMetadataNoneOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCompetitionGet$JsonOdataMetadataNoneOdataStreamingFalse(params?: ApiCompetitionGet$JsonOdataMetadataNoneOdataStreamingFalse$Params, context?: HttpContext): Observable<CompetitionModelListResult> {
    return this.apiCompetitionGet$JsonOdataMetadataNoneOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<CompetitionModelListResult>): CompetitionModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCompetitionGet$JsonOdataMetadataNone()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCompetitionGet$JsonOdataMetadataNone$Response(params?: ApiCompetitionGet$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<StrictHttpResponse<CompetitionModelListResult>> {
    return apiCompetitionGet$JsonOdataMetadataNone(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCompetitionGet$JsonOdataMetadataNone$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCompetitionGet$JsonOdataMetadataNone(params?: ApiCompetitionGet$JsonOdataMetadataNone$Params, context?: HttpContext): Observable<CompetitionModelListResult> {
    return this.apiCompetitionGet$JsonOdataMetadataNone$Response(params, context).pipe(
      map((r: StrictHttpResponse<CompetitionModelListResult>): CompetitionModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCompetitionGet$JsonOdataStreamingTrue()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCompetitionGet$JsonOdataStreamingTrue$Response(params?: ApiCompetitionGet$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<CompetitionModelListResult>> {
    return apiCompetitionGet$JsonOdataStreamingTrue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCompetitionGet$JsonOdataStreamingTrue$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCompetitionGet$JsonOdataStreamingTrue(params?: ApiCompetitionGet$JsonOdataStreamingTrue$Params, context?: HttpContext): Observable<CompetitionModelListResult> {
    return this.apiCompetitionGet$JsonOdataStreamingTrue$Response(params, context).pipe(
      map((r: StrictHttpResponse<CompetitionModelListResult>): CompetitionModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCompetitionGet$JsonOdataStreamingFalse()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCompetitionGet$JsonOdataStreamingFalse$Response(params?: ApiCompetitionGet$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<StrictHttpResponse<CompetitionModelListResult>> {
    return apiCompetitionGet$JsonOdataStreamingFalse(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCompetitionGet$JsonOdataStreamingFalse$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCompetitionGet$JsonOdataStreamingFalse(params?: ApiCompetitionGet$JsonOdataStreamingFalse$Params, context?: HttpContext): Observable<CompetitionModelListResult> {
    return this.apiCompetitionGet$JsonOdataStreamingFalse$Response(params, context).pipe(
      map((r: StrictHttpResponse<CompetitionModelListResult>): CompetitionModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCompetitionGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCompetitionGet$Json$Response(params?: ApiCompetitionGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CompetitionModelListResult>> {
    return apiCompetitionGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCompetitionGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCompetitionGet$Json(params?: ApiCompetitionGet$Json$Params, context?: HttpContext): Observable<CompetitionModelListResult> {
    return this.apiCompetitionGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<CompetitionModelListResult>): CompetitionModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCompetitionGet$Xml()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCompetitionGet$Xml$Response(params?: ApiCompetitionGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<CompetitionModelListResult>> {
    return apiCompetitionGet$Xml(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCompetitionGet$Xml$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCompetitionGet$Xml(params?: ApiCompetitionGet$Xml$Params, context?: HttpContext): Observable<CompetitionModelListResult> {
    return this.apiCompetitionGet$Xml$Response(params, context).pipe(
      map((r: StrictHttpResponse<CompetitionModelListResult>): CompetitionModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCompetitionGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCompetitionGet$Plain$Response(params?: ApiCompetitionGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CompetitionModelListResult>> {
    return apiCompetitionGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCompetitionGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCompetitionGet$Plain(params?: ApiCompetitionGet$Plain$Params, context?: HttpContext): Observable<CompetitionModelListResult> {
    return this.apiCompetitionGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CompetitionModelListResult>): CompetitionModelListResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiCompetitionGet$Any()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCompetitionGet$Any$Response(params?: ApiCompetitionGet$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<CompetitionModelListResult>> {
    return apiCompetitionGet$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiCompetitionGet$Any$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiCompetitionGet$Any(params?: ApiCompetitionGet$Any$Params, context?: HttpContext): Observable<CompetitionModelListResult> {
    return this.apiCompetitionGet$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<CompetitionModelListResult>): CompetitionModelListResult => r.body)
    );
  }

}
